<template>
  <div>
    <div class="container-grid">
      <div class="container-group">
        <label class="label">
          <i class="fas fa-user-tie mr-2F"></i>
          Tipo
        </label>

        <div class="date-input-container">
          <v-select
            v-model="type"
            :items="selectTypes"
            item-text="label"
            item-value="value"
            label="Selecione uma opção"
            outlined
            dense
            clearable
            placeholder="Escolha..."
          ></v-select>
        </div>
      </div>

      <div class="container-group button-group">
        <v-btn :disabled="loading" @click="create" class="btn-save-modern">
          <i class="fas fa-save mr-2"></i>
          {{ loading ? "Salvando..." : "Salvar" }}
          <div v-if="loading" class="btn-spinner">
            <i class="fas fa-spinner fa-spin"></i>
          </div>
        </v-btn>
      </div>
    </div>

    <div class="table-card">
      <b-overlay :show="loading" opacity="0.99" class="loading-overlay">
        <v-data-table
          :headers="headers"
          :items="technicalResponsible"
          item-key="id"
          :footer-props="{
            'items-per-page-options': [10, 50, 100],
            'items-per-page-text': 'Mostrar',
          }"
          class="modern-table"
          :no-data-text="'Nenhuma informação técnica encontrada'"
          :loading="loading"
          :loading-text="'Carregando informações...'"
        >
          <template v-slot:[`item.type`]="{ item }">
            {{ getTypeLabel(item.type) }}
          </template>

          <template v-slot:[`item.action`]="{ item }">
            <confirmation-dialog
              v-if="item.id"
              message-title="EXCLUIR"
              message-body="Tem certeza que deseja desvincular informações do Responsável Técnico"
              open-class="btn-modern btn-modern-delete"
              open-left-icon="fa-trash"
              open-text="Excluir"
              @yes="deleteTechinicalManager(item.id)"
            />
          </template>
        </v-data-table>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import ConfirmationDialog from "../Components/ConfirmationDialog";

import api from "../../services/api";

import toast from "../../lib/ToastNotification";

export default {
  name: "TechnicalManager",

  components: {
    ConfirmationDialog,
  },

  props: {
    user_id: {
      type: [Number, String],
    },
  },

  data() {
    return {
      type: null,

      technicalResponsible: [],

      selectTypes: [
        { label: "Prescrição", value: "PRESCRICAO" },
        { label: "Evolução Medico", value: "EVOLUCAO_MEDICO" },
        { label: "Evolução Nutricionista", value: "EVOLUCAO_NUTRICIONISTA" },
        { label: "Evolução Fisioterapeuta", value: "EVOLUCAO_FISIOTERAPEUTA" },
        { label: "Evolução Psicólogo", value: "EVOLUCAO_PSICOLOGO" },
        { label: "Evolução Enfermeiro", value: "EVOLUCAO_ENFERMEIRO" },
        { label: "Evolução Fonoaudiólogo", value: "EVOLUCAO_FONOAUDIOLOGO" },
        {
          label: "Evolução Terapeuta Ocupacional",
          value: "EVOLUCAO_TERAPEUTA_OCUPACIONAL",
        },
        { label: "Evolução Musicoterapia", value: "EVOLUCAO_MUSICOTERAPIA" },
        {
          label: "Evolução Assistente Social",
          value: "EVOLUCAO_ASSISTENTE_SOCIAL",
        },
        {
          label: "Evolução Educador Físico",
          value: "EVOLUCAO_EDUCADOR_FISICO",
        },
        {
          label: "Evolução Educadores e Pedagogos",
          value: "EVOLUCAO_EDUCADORES_E_PEDAGOGOS",
        },
        { label: "Evolução Dentista", value: "EVOLUCAO_DENTISTA" },
        { label: "Semiologia", value: "SEMIOLOGIA" },
      ],

      headers: [
        {
          text: "Tipo",
          value: "type",
        },
        {
          text: "Ações",
          value: "action",
        },
      ],

      loading: false,
    };
  },

  async created() {
    await this.get();
  },

  methods: {
    async get() {
      try {
        this.loading = true;

        let params = { user_id: this.user_id };

        const response = await api.get("/technical-responsible", { params });

        const { error, technicalResponsible } = response.data;

        if (!error) {
          this.technicalResponsible = technicalResponsible;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.error(error);
      }
    },

    async create() {
      try {
        this.loading = true;

        const { user_id, type } = this;

        let params = {
          user_id,
          type,
        };

        const response = await api.post("/technical-responsible", params);

        const { error, message } = response.data;

        if (!error) {
          this.type = null;

          await this.get();

          toast(message, "success");
        } else {
          toast(message, "error");
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    async deleteTechinicalManager(id) {
      try {
        this.loading = true;

        const { user_id } = this;

        let params = {
          id,
          user_id,
        };

        const response = await api.delete("/technical-responsible", { params });

        const { error, message } = response.data;

        if (!error) {
          await this.get();

          toast(message, "success");
        } else {
          toast(message, "error");
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    getTypeLabel(type) {
      let typeLabel = this.selectTypes.find(
        (selectType) => selectType.value == type
      );

      return typeLabel ? typeLabel.label : type;
    },
  },
};
</script>

<style scoped>
.container-grid {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 20px;
  align-items: end;
}

.container-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

.table-card {
  margin-top: 32px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  padding: 24px;
}

.date-input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.btn-save-modern {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3) !important;
  transition: all 0.3s ease !important;
  min-width: 120px !important;
  height: 48px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.btn-save-modern:disabled {
  opacity: 0.7 !important;
  cursor: not-allowed !important;
  transform: none !important;
}

.btn-save-modern:hover:not(:disabled) {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4) !important;
}

.btn-spinner {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
}

.error-section {
  margin: -16px 0 0 0;
}

/* Responsivo */
@media (max-width: 1024px) {
  .container-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .button-group {
    justify-self: end;
  }
}

@media (max-width: 768px) {
  .container {
    padding: 16px;
  }
  .container-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  .btn-save-modern {
    width: 100%;
    min-width: unset !important;
  }
}
</style>